export default class Calendar {
  constructor(selectedDate = {}, lang) {
    this.currentDate = {
      year: selectedDate.year,
      month: selectedDate.month,
      date: selectedDate.date,
      firstDayOfWeek: selectedDate.firstDayOfWeek
    }

    this.currentYear = new Date().getFullYear()
    this.lang = lang
    this.years = [...Array(21)].map((i, index) => this.currentYear + index)
    this.months = this.getMonths()
    this.days = this.getDays()
    this.firstDayOfMonth = this.getFirstDayOfMonth()
    this.dates = this.getDates()
    this.daysOfMonth = this.showDates()
    this.weeksOfMonth = this.getWeekOfMonth()
  }

  getDays() {
    let days = []
    let dayNumber
    let name
    for (let index = 1; index <= 7; index++) {
      name = new Date(this.currentDate.year, '00', index).toLocaleString(this.lang, { weekday: 'long' })
      dayNumber = parseInt(new Date(this.currentDate.year, '00', index).getDay())
      if (this.currentDate.firstDayOfWeek === 1) {
        dayNumber = ((dayNumber - 1) + 7) % 7
      }
      days.push({ name, dayNumber })
    }
    this.sortDays(days)
    return days
  }

  getMonths() {
    let months = []
    for (let index = 0; index < 12; index++) {
      let name = new Date(this.currentDate.year, index).toLocaleString(this.lang, { month: 'long' })
      months.push({index, name})
    }
    return months
  }
  getDates() {
    let dates = []
    for (let index = 1; index < 366; index++) {
      let date = new Date(this.currentDate.year, '00', index)
      dates.push(date)
    }
    return dates
  }

  showDates() {
    let countDateYears = this.dates.findIndex(item => new Date(item).getMonth() === this.currentDate.month)
    let daysOfMonth = this.dates.filter(item => new Date(item).getMonth() === this.currentDate.month)
    let dates = []
    let prevDay = this.firstDayOfMonth
    const prevYearLastOfMount = new Date(this.currentDate.year, '00', 1).getDate()
    if (this.currentDate.month === 0) {
      while (prevDay > 0) {
        let date = new Date(this.currentDate.year, '00', prevYearLastOfMount - prevDay)
        dates.push({
          date: date,
          isActive: false
        })
        prevDay -= 1
      }
    } else {
      while (prevDay > 0 && countDateYears - prevDay > 0) {
        dates.push({
          date: this.dates[countDateYears - prevDay],
          isActive: false
        })
        prevDay -= 1
      }
    } // ayın başlangıç günü öncesinde listelenemesi gereken günler
    daysOfMonth = daysOfMonth.map(item => ({
      date: item,
      isActive: true
    }))
    dates = dates.concat(daysOfMonth) // ayın tüm günleri
    let nextDay = 0
    let totalCount
    while (dates.length % 7) {
      totalCount = countDateYears + daysOfMonth.length + nextDay
      let date = totalCount < 365 ? this.dates[countDateYears + daysOfMonth.length + nextDay]
        : new Date(this.currentDate.year + 1, '00', nextDay + 1)
      dates.push({
        date,
        isActive: false
      })
      nextDay += 1
      // ayın bitişinden sonraki kalan alanı doldurmak için listelenmesi gereken günler.
    }
    dates = dates.map(item => ({
      mouth: new Date(item.date).getMonth(),
      day: new Date(item.date).getDate(),
      date: new Date(item.date).toDateString(),
      fullDate: item.date,
      isActive: item.isActive
    }))
    return dates
  }

  getFirstDayOfMonth() {
    /* hafta başlangıcı ( 0.gün ) default pazar olarak geleceğinden
       eğer kullanıcı hafta başlangıcını pazartesi olarak seçerse
       buna göre ilk gün hesaplaması yapıldı.
    */
    let firstDay = new Date(this.currentDate.year, this.currentDate.month, '01').getDay() // ayın ilk günü
    if (this.currentDate.firstDayOfWeek === 1) {
      firstDay = ((firstDay - 1) + 7) % 7
    }
    return parseInt(firstDay)
  }

  sortDays(days) {
    return days.sort(function(a, b) {
      return a.dayNumber - b.dayNumber
    })
  }

  getWeekOfMonth() {
    let weeks = []
    // Get first date of a month
    let dt = new Date(this.daysOfMonth[0].fullDate)
    let startingWeekOfMonth = getWeeksofMonth(dt)
    if (this.currentDate.firstDayOfWeek === 0) startingWeekOfMonth++ // Add weekNo to 1 when first day of the week is Sunday because in calc of weeks it takes previous week as a starting point
    const rows = Math.round(this.daysOfMonth.length / 7) //  tüm veriyi column sayısı olan 7 ye bölüp takvim kaç satırdan oluştuğunu bulduk.
    for (let index = 0; index < rows; index++) {
      if (startingWeekOfMonth >= 52) startingWeekOfMonth = 1 // Resetting date to 1 when year is finished
      let weekNo = startingWeekOfMonth + index
      weeks.push({
        index: weekNo,
        name: weekNo
      })
    }
    return weeks
  }

  /* getWeekOfMonth() {
    let weeks = []
    let dt = new Date()
    let te = getWeeksTest(dt)
    console.log(te)
    const rows = Math.round(this.daysOfMonth.length / 7) //  tüm veriyi column sayısı olan 7 ye bölüp takvim kaç satırdan oluştuğunu bulduk.
    for (let index = 0; index < rows; index++) {
      let countDateYears = this.dates.findIndex(item => new Date(item).getMonth() === this.currentDate.month)
      let weekNo = Math.floor(countDateYears / 7) + index + 1
      weeks.push({
        index: weekNo,
        name: weekNo
      })
    }
    return weeks
  } */
}

function getWeeksofMonth(dt) {
  let dateValue = new Date(dt.valueOf())
  let dayn = (dt.getDay() + 6) % 7
  dateValue.setDate(dateValue.getDate() - dayn + 3)
  let firstThursday = dateValue.valueOf()
  dateValue.setMonth(0, 1)
  if (dateValue.getDay() !== 4) {
    dateValue.setMonth(0, 1 + ((4 - dateValue.getDay()) + 7) % 7)
  }
  return 1 + Math.ceil((firstThursday - dateValue) / 604800000)
}
